var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconSummaries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.284,
    height: 19,
    viewBox: "0 0 19.284 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Summaries",
    transform: "translate(-0.001 -0.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36123",
    "data-name": "Path 36123",
    d: "M62.426,56.421a3.887,3.887,0,1,0-1.95,7.255,3.916,3.916,0,0,0,1.012-.134,3.887,3.887,0,0,0,.938-7.121Zm1.215,5.19a3.65,3.65,0,1,1-1.335-4.983,3.626,3.626,0,0,1,1.335,4.983Z",
    transform: "translate(-45.681 -44.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36124",
    "data-name": "Path 36124",
    d: "M76.568,67.868a.12.12,0,0,0,.06-.224l-1.075-.621a.373.373,0,0,0-.246-.426v-1.7a.12.12,0,1,0-.24,0v1.7a.37.37,0,0,0-.2.167.373.373,0,0,0,.57.467l1.076.621a.116.116,0,0,0,.059.015Zm-1.449-.8a.135.135,0,0,1-.049-.184.133.133,0,0,1,.081-.063.137.137,0,0,1,.035,0,.134.134,0,0,1,.067.018.136.136,0,0,1,.063.081.133.133,0,0,1-.014.1A.136.136,0,0,1,75.119,67.068Z",
    transform: "translate(-60.385 -51.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36125",
    "data-name": "Path 36125",
    d: "M89.666,83.174l-.492-.284a.12.12,0,1,0-.12.207l.492.284a.12.12,0,0,0,.163-.044A.119.119,0,0,0,89.666,83.174Z",
    transform: "translate(-71.832 -66.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36126",
    "data-name": "Path 36126",
    d: "M90.98,75.565a.12.12,0,0,0,.12.12h.569a.12.12,0,1,0,0-.24H91.1A.12.12,0,0,0,90.98,75.565Z",
    transform: "translate(-73.434 -60.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36127",
    "data-name": "Path 36127",
    d: "M89.01,67.009a.119.119,0,0,0,.1.06.121.121,0,0,0,.06-.016l.492-.284a.12.12,0,0,0-.12-.207l-.492.284A.12.12,0,0,0,89.01,67.009Z",
    transform: "translate(-71.831 -53.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36128",
    "data-name": "Path 36128",
    d: "M84.021,60.037a.12.12,0,0,0-.163.044l-.284.493a.12.12,0,0,0,.044.163.12.12,0,0,0,.163-.044l.284-.493A.119.119,0,0,0,84.021,60.037Z",
    transform: "translate(-67.442 -47.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36129",
    "data-name": "Path 36129",
    d: "M76.249,58.452a.12.12,0,0,0,.12-.12v-.568a.12.12,0,1,0-.24,0v.568A.12.12,0,0,0,76.249,58.452Z",
    transform: "translate(-61.447 -45.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36130",
    "data-name": "Path 36130",
    d: "M67.525,60.7a.12.12,0,0,0,.1.06.121.121,0,0,0,.06-.016.12.12,0,0,0,.044-.163l-.284-.493a.12.12,0,0,0-.207.12Z",
    transform: "translate(-54.26 -47.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36131",
    "data-name": "Path 36131",
    d: "M61.38,66.846l-.492-.284a.12.12,0,1,0-.12.207l.492.284a.12.12,0,0,0,.163-.044.12.12,0,0,0-.044-.163Z",
    transform: "translate(-49.001 -53.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36132",
    "data-name": "Path 36132",
    d: "M59.136,75.565a.12.12,0,0,0-.12-.12h-.568a.12.12,0,1,0,0,.24h.568A.12.12,0,0,0,59.136,75.565Z",
    transform: "translate(-47.079 -60.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36133",
    "data-name": "Path 36133",
    d: "M61.261,82.89l-.492.284a.12.12,0,0,0,.06.224.121.121,0,0,0,.06-.016l.492-.284a.12.12,0,0,0-.12-.208Z",
    transform: "translate(-49.001 -66.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36134",
    "data-name": "Path 36134",
    d: "M67.689,88.327a.12.12,0,0,0-.163.044l-.284.493a.12.12,0,0,0,.044.163.12.12,0,0,0,.163-.044l.284-.493A.119.119,0,0,0,67.689,88.327Z",
    transform: "translate(-54.26 -70.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36135",
    "data-name": "Path 36135",
    d: "M76.249,90.3a.12.12,0,0,0-.12.12v.568a.12.12,0,0,0,.24,0v-.568A.12.12,0,0,0,76.249,90.3Z",
    transform: "translate(-61.447 -72.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36136",
    "data-name": "Path 36136",
    d: "M83.78,88.371a.12.12,0,1,0-.207.12l.284.493a.12.12,0,0,0,.1.06.121.121,0,0,0,.06-.016.12.12,0,0,0,.044-.163Z",
    transform: "translate(-67.443 -70.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36137",
    "data-name": "Path 36137",
    d: "M62.312,56.148a4.48,4.48,0,1,0-4.336,5.644,4.512,4.512,0,0,0,1.167-.154,4.482,4.482,0,0,0,3.169-5.489Zm-.655,3.281a4.242,4.242,0,1,1,.424-3.22,4.211,4.211,0,0,1-.424,3.22Z",
    transform: "translate(-43.181 -41.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36138",
    "data-name": "Path 36138",
    d: "M57.735,10.528a3.887,3.887,0,1,0,0-5.5,3.863,3.863,0,0,0,0,5.5ZM57.9,5.2a3.648,3.648,0,1,1,0,5.158A3.653,3.653,0,0,1,57.9,5.2Z",
    transform: "translate(-45.682 -2.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36139",
    "data-name": "Path 36139",
    d: "M71.192,14.763a.375.375,0,0,0,.07.429h0a.374.374,0,1,0,.385-.617V12.87a.12.12,0,1,0-.24,0v1.7a.346.346,0,0,0-.046.019l-.878-.878a.12.12,0,0,0-.169.169Zm.429.26a.134.134,0,1,1,0-.19.135.135,0,0,1,0,.19Z",
    transform: "translate(-56.726 -9.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36140",
    "data-name": "Path 36140",
    d: "M63.657,34.566a.119.119,0,0,0,.084-.035l.4-.4a.12.12,0,0,0-.169-.169l-.4.4a.12.12,0,0,0,0,.169A.117.117,0,0,0,63.657,34.566Z",
    transform: "translate(-51.283 -26.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36141",
    "data-name": "Path 36141",
    d: "M59.569,27.272l-.549.147a.12.12,0,0,0,.031.236.144.144,0,0,0,.031,0l.549-.147a.12.12,0,0,0-.062-.232Z",
    transform: "translate(-47.565 -21.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36142",
    "data-name": "Path 36142",
    d: "M59.631,18.966l-.549-.148a.12.12,0,0,0-.063.231l.549.148a.113.113,0,0,0,.031,0,.12.12,0,0,0,.032-.236Z",
    transform: "translate(-47.565 -14.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36143",
    "data-name": "Path 36143",
    d: "M63.974,11.44a.12.12,0,0,0,.085.035.118.118,0,0,0,.084-.035.12.12,0,0,0,0-.169l-.4-.4a.12.12,0,0,0-.169.169Z",
    transform: "translate(-51.284 -8.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36144",
    "data-name": "Path 36144",
    d: "M71.67,6.922a.12.12,0,0,0,.115.089.144.144,0,0,0,.031,0A.121.121,0,0,0,71.9,6.86l-.146-.549a.12.12,0,1,0-.232.062Z",
    transform: "translate(-57.726 -4.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36145",
    "data-name": "Path 36145",
    d: "M80.061,7.009a.113.113,0,0,0,.031,0,.12.12,0,0,0,.115-.089l.148-.549a.12.12,0,1,0-.231-.063l-.148.549a.121.121,0,0,0,.085.147Z",
    transform: "translate(-64.549 -4.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36146",
    "data-name": "Path 36146",
    d: "M86.754,11.472a.122.122,0,0,0,.085-.035l.4-.4a.12.12,0,0,0-.17-.169l-.4.4a.12.12,0,0,0,0,.169A.117.117,0,0,0,86.754,11.472Z",
    transform: "translate(-69.927 -8.102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36147",
    "data-name": "Path 36147",
    d: "M90.6,19.2a.106.106,0,0,0,.031,0l.548-.148a.12.12,0,1,0-.063-.231l-.548.148a.12.12,0,0,0,.032.236Z",
    transform: "translate(-73.029 -14.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36148",
    "data-name": "Path 36148",
    d: "M90.568,27.5l.548.147a.114.114,0,0,0,.031,0,.12.12,0,0,0,.031-.236l-.548-.147a.12.12,0,1,0-.062.231Z",
    transform: "translate(-73.03 -21.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36149",
    "data-name": "Path 36149",
    d: "M87.068,34.537a.12.12,0,0,0,.084.035.118.118,0,0,0,.084-.035.12.12,0,0,0,0-.169l-.4-.4a.12.12,0,0,0-.169.169Z",
    transform: "translate(-69.923 -26.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36150",
    "data-name": "Path 36150",
    d: "M80.119,38.471a.12.12,0,0,0,.115.089.106.106,0,0,0,.031,0,.12.12,0,0,0,.084-.147l-.148-.549a.12.12,0,1,0-.231.063Z",
    transform: "translate(-64.544 -29.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36151",
    "data-name": "Path 36151",
    d: "M71.818,37.776a.12.12,0,0,0-.147.085l-.146.549a.12.12,0,0,0,.085.147.112.112,0,0,0,.031,0,.119.119,0,0,0,.115-.089l.146-.549A.12.12,0,0,0,71.818,37.776Z",
    transform: "translate(-57.727 -29.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36152",
    "data-name": "Path 36152",
    d: "M58,9.768a4.482,4.482,0,0,0,3.169-7.651,4.482,4.482,0,0,0-6.338,6.338A4.456,4.456,0,0,0,58,9.768ZM55,2.286a4.243,4.243,0,1,1,6,6,4.243,4.243,0,0,1-6-6Z",
    transform: "translate(-43.194 -0.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36153",
    "data-name": "Path 36153",
    d: "M5.968,11.529a3.916,3.916,0,0,0,1.012.134,3.9,3.9,0,1,0-1.012-.134ZM5.152,4.616A3.648,3.648,0,1,1,3.816,9.6,3.623,3.623,0,0,1,5.152,4.616Z",
    transform: "translate(-2.492 -2.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36154",
    "data-name": "Path 36154",
    d: "M15.523,15.622a.119.119,0,0,0,.06.223.121.121,0,0,0,.06-.016l1.074-.621a.375.375,0,0,0,.247.093.373.373,0,0,0,.12-.727v-1.7a.12.12,0,0,0-.24,0v1.7a.342.342,0,0,0-.068.031.372.372,0,0,0-.179.4Zm1.31-.728a.135.135,0,0,1,.129-.1.134.134,0,1,1-.115.2A.13.13,0,0,1,16.833,14.894Z",
    transform: "translate(-12.48 -9.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36155",
    "data-name": "Path 36155",
    d: "M7.75,30.866l-.492.285a.119.119,0,0,0,.06.223.121.121,0,0,0,.06-.016l.492-.285a.12.12,0,0,0-.12-.207Z",
    transform: "translate(-5.809 -24.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36156",
    "data-name": "Path 36156",
    d: "M5.618,23.542a.12.12,0,0,0-.12-.12H4.928a.12.12,0,0,0,0,.24H5.5A.12.12,0,0,0,5.618,23.542Z",
    transform: "translate(-3.88 -18.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36157",
    "data-name": "Path 36157",
    d: "M7.257,14.745l.492.285a.114.114,0,0,0,.06.016.119.119,0,0,0,.06-.223l-.492-.285a.12.12,0,0,0-.12.207Z",
    transform: "translate(-5.809 -11.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36158",
    "data-name": "Path 36158",
    d: "M14.017,8.677a.12.12,0,0,0,.1.06.121.121,0,0,0,.06-.016.12.12,0,0,0,.044-.163l-.284-.493a.12.12,0,0,0-.207.12Z",
    transform: "translate(-11.071 -5.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36159",
    "data-name": "Path 36159",
    d: "M22.741,6.425a.12.12,0,0,0,.12-.12V5.737a.12.12,0,1,0-.24,0V6.3A.12.12,0,0,0,22.741,6.425Z",
    transform: "translate(-18.258 -3.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36160",
    "data-name": "Path 36160",
    d: "M30.1,8.718a.12.12,0,0,0,.163-.044l.284-.493a.12.12,0,1,0-.207-.12l-.284.493A.12.12,0,0,0,30.1,8.718Z",
    transform: "translate(-24.25 -5.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36161",
    "data-name": "Path 36161",
    d: "M35.6,15.045a.121.121,0,0,0,.06-.016l.492-.285a.12.12,0,0,0-.12-.207l-.492.285a.119.119,0,0,0,.06.223Z",
    transform: "translate(-28.639 -11.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36162",
    "data-name": "Path 36162",
    d: "M37.473,23.542a.12.12,0,0,0,.12.12h.569a.12.12,0,0,0,0-.24h-.569A.12.12,0,0,0,37.473,23.542Z",
    transform: "translate(-30.246 -18.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36163",
    "data-name": "Path 36163",
    d: "M35.547,31.073l.492.285a.114.114,0,0,0,.06.016.119.119,0,0,0,.06-.223l-.492-.285a.12.12,0,1,0-.12.207Z",
    transform: "translate(-28.642 -24.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36164",
    "data-name": "Path 36164",
    d: "M30.346,36.959a.12.12,0,0,0,.1.06.121.121,0,0,0,.06-.016.12.12,0,0,0,.044-.163l-.284-.493a.12.12,0,1,0-.207.12Z",
    transform: "translate(-24.251 -28.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36165",
    "data-name": "Path 36165",
    d: "M22.741,38.277a.12.12,0,0,0-.12.12v.569a.12.12,0,0,0,.24,0V38.4A.12.12,0,0,0,22.741,38.277Z",
    transform: "translate(-18.258 -30.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36166",
    "data-name": "Path 36166",
    d: "M14.181,36.3a.12.12,0,0,0-.163.044l-.284.493a.12.12,0,0,0,.044.163.12.12,0,0,0,.163-.044l.284-.493a.119.119,0,0,0-.044-.163Z",
    transform: "translate(-11.071 -28.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36167",
    "data-name": "Path 36167",
    d: "M.6,7.518A4.483,4.483,0,1,0,2.241,1.4,4.487,4.487,0,0,0,.6,7.518ZM2.361,1.6A4.243,4.243,0,1,1,.808,7.4,4.217,4.217,0,0,1,2.361,1.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36168",
    "data-name": "Path 36168",
    d: "M4.551,57.056a3.887,3.887,0,1,0,5.5,0,3.891,3.891,0,0,0-5.5,0ZM9.88,62.383a3.646,3.646,0,1,1,0-5.158,3.654,3.654,0,0,1,0,5.158Z",
    transform: "translate(-2.755 -44.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36169",
    "data-name": "Path 36169",
    d: "M23.042,65.736l-.878.877a.345.345,0,0,0-.046-.019v-1.7a.12.12,0,0,0-.24,0v1.7a.372.372,0,0,0-.144.616.367.367,0,0,0,.263.11h0a.372.372,0,0,0,.334-.538l.878-.877a.12.12,0,0,0-.169-.169Zm-.948,1.306a.135.135,0,0,1-.1.04h0a.132.132,0,0,1-.094-.04A.134.134,0,0,1,22,66.814a.134.134,0,0,1,.1.228Z",
    transform: "translate(-17.455 -51.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36170",
    "data-name": "Path 36170",
    d: "M33.652,85.986a.12.12,0,0,0-.169.169l.4.4a.12.12,0,0,0,.085.035.118.118,0,0,0,.084-.035.12.12,0,0,0,0-.169Z",
    transform: "translate(-26.996 -68.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36171",
    "data-name": "Path 36171",
    d: "M37.377,79.523l.549.148a.114.114,0,0,0,.031,0,.12.12,0,0,0,.031-.236l-.549-.148a.12.12,0,1,0-.062.231Z",
    transform: "translate(-30.097 -63.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36172",
    "data-name": "Path 36172",
    d: "M37.407,71.228a.144.144,0,0,0,.031,0l.549-.147a.12.12,0,0,0-.063-.231l-.549.147a.12.12,0,0,0,.032.235Z",
    transform: "translate(-30.095 -56.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36173",
    "data-name": "Path 36173",
    d: "M33.884,62.888l-.4.4a.119.119,0,0,0,.084.2.122.122,0,0,0,.085-.035l.4-.4a.12.12,0,1,0-.169-.169Z",
    transform: "translate(-26.996 -50.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36174",
    "data-name": "Path 36174",
    d: "M26.876,59.025a.109.109,0,0,0,.031,0,.121.121,0,0,0,.116-.089l.146-.549a.12.12,0,0,0-.232-.062l-.146.549a.119.119,0,0,0,.085.147Z",
    transform: "translate(-21.62 -46.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36175",
    "data-name": "Path 36175",
    d: "M18.565,58.332a.12.12,0,1,0-.231.063l.148.549a.12.12,0,0,0,.115.089.106.106,0,0,0,.031,0,.12.12,0,0,0,.084-.147Z",
    transform: "translate(-14.794 -46.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36176",
    "data-name": "Path 36176",
    d: "M10.558,62.888a.12.12,0,0,0-.169.169l.4.4a.12.12,0,0,0,.085.035.118.118,0,0,0,.084-.035.12.12,0,0,0,0-.169Z",
    transform: "translate(-8.356 -50.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36177",
    "data-name": "Path 36177",
    d: "M5.831,71.074l.548.147a.114.114,0,0,0,.031,0,.12.12,0,0,0,.031-.236l-.548-.147a.12.12,0,1,0-.062.231Z",
    transform: "translate(-4.634 -56.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36178",
    "data-name": "Path 36178",
    d: "M6.381,79.293l-.548.148a.12.12,0,0,0,.031.236.105.105,0,0,0,.031,0l.548-.148a.12.12,0,0,0-.062-.231Z",
    transform: "translate(-4.635 -63.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36179",
    "data-name": "Path 36179",
    d: "M10.79,85.985l-.4.4a.119.119,0,0,0,.084.2.122.122,0,0,0,.085-.035l.4-.4a.12.12,0,1,0-.169-.169Z",
    transform: "translate(-8.356 -68.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36180",
    "data-name": "Path 36180",
    d: "M18.629,89.8a.12.12,0,0,0-.147.084l-.148.549a.12.12,0,0,0,.084.147.113.113,0,0,0,.031,0,.12.12,0,0,0,.115-.089l.148-.549A.119.119,0,0,0,18.629,89.8Z",
    transform: "translate(-14.794 -71.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36181",
    "data-name": "Path 36181",
    d: "M27.021,89.885a.12.12,0,0,0-.232.062l.146.549a.12.12,0,0,0,.116.089.144.144,0,0,0,.031,0,.121.121,0,0,0,.085-.147Z",
    transform: "translate(-21.618 -71.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36182",
    "data-name": "Path 36182",
    d: "M4.813,52.824a4.483,4.483,0,1,0,3.169,1.313,4.45,4.45,0,0,0-3.169-1.313Zm3,7.482a4.243,4.243,0,1,1,0-6A4.215,4.215,0,0,1,7.814,60.306Z",
    transform: "translate(-0.269 -41.997)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconSummaries);
export default __webpack_public_path__ + "static/media/Menu_Icon_Summaries.3f557ae9.svg";
export { ForwardRef as ReactComponent };